import { ScrollView } from 'react-native';
import styled from 'styled-components/native';
import ImageComp from '~/components/Image';

const COLOR_BOX_HEIGHT_MOBILE = 200;

export const Content = styled.View`
  flex: 1;
`;

export const ColorBox = styled.View<{ isDesktop?: boolean }>`
  position: absolute;
  background-color: ${({ theme }) => theme.color.brand_01};
  z-index: -1;
  top: 0px;
  left: 0px;
  right: 0px;
  height: ${({ theme }) =>
    COLOR_BOX_HEIGHT_MOBILE + theme.safeAreaInsets.top}px;
`;

export const ScrollContent = styled(ScrollView).attrs({
  contentContainerStyle: {
    flex: 1,
  },
})`
  padding-horizontal: ${({ theme }) => theme.spacing.medium};
`;

export const SmallImage = styled(ImageComp)`
  width: 92px;
  height: 74px;
  margin-left: -18px;
  margin-top: 20px;
  transform: rotate(-10deg);
`;

export const Image = styled(ImageComp)`
  width: 160px;
  height: 160px;
  border-radius: 5px;
  transform: rotate(10deg);
  margin-left: 22px;
  border-width: 5px;
  border-color: ${({ theme }) => theme.color.base.c2};
  margin-vertical: 36px;
  background-color: ${({ theme }) => theme.color.base.c1};
`;

export const ImageWrapper = styled.View`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
`;

export const Title = styled.Text`
  font-family: ${({ theme }) => theme.fontFamily.core.w600};
  color: ${({ theme }) => theme.color.brand_02};
  font-size: 32px;
  line-height: 38px;
`;

export const Footer = styled.View`
  margin-bottom: 24px;
`;

export const Descp = styled.Text`
  margin-top: 32px;
  font-family: ${({ theme }) => theme.fontFamily.core.w400};
  color: ${({ theme }) => theme.color.base.c10};
  font-size: 18px;
  line-height: 24px;
`;
